import api from './client';

/** Непрочитанные объявления на сайте для текущего пользователя. */
export async function fetchUnreadNotices() {
  const res = await api.get('/messaging/notices/');
  return Array.isArray(res.data) ? res.data : [];
}

/** Отметить объявление прочитанным (скрыть плашку). */
export async function markNoticeRead(noticeId) {
  await api.post(`/messaging/notices/${noticeId}/read/`);
}
